import { VerificationStatus } from "../common/constant";

export const getStatusColor = (status) => {
    switch (status) {
        case VerificationStatus.DRAFT:
            return "blue";
        case VerificationStatus.INCOMPLETE:
            return "gold";
        case VerificationStatus.SUBMITTED:
            return "cyan";
        case VerificationStatus.PENDING:
            return "gold";
        case VerificationStatus.VERIFIED:
            return "green";
        case VerificationStatus.FAILED:
            return "red";
        case VerificationStatus.EXPIRED:
            return "gray";
        default:
            return "default";
    }
};
